import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

const logoFilenames = [
  'logo-aetna.webp',
  'logo-bcbs.webp',
  'logo-cigna.webp',
  'logo-first-choice.webp',
  'logo-honor-health.webp',
  'logo-kaiser-permanente.webp',
  'logo-lifewise.webp',
  'logo-pacific-source.webp',
  'logo-premera.webp',
  'logo-providence.webp',
  'logo-regence.webp',
  'logo-united.webp',
];

const InsuranceLogoGallery: React.FC = () => {
  return (
    <section className="py-5 bg-body-tertiary border-top">
      <Container>
        <h5 className="text-center mb-4 fw-semibold">
          We accept many insurance plans, including:
        </h5>
        <Row className="justify-content-center gy-4">
          {logoFilenames.map((filename) => (
            <Col
              key={filename}
              xs={5}
              sm={4}
              md={3}
              lg={2}
              className="text-center d-flex align-items-center justify-content-center"
            >
              <div
                className="p-3 w-100 d-flex align-items-center justify-content-center"
                style={{ height: '80px' }}
              >
                <Image
                  src={`/images/insurance_logos/${filename}`}
                  alt={filename.replace('logo-', '').replace('.webp', '')}
                  fluid
                  style={{ maxHeight: '50px', objectFit: 'contain' }}
                />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default InsuranceLogoGallery;
